import { DrawerFilterType } from '../../../models';

export const projectsFilters = [
  {
    label: 'Status',
    name: 'status',
    type: DrawerFilterType.SELECT,
    value: '',
    list: [
      {
        text: 'Pending',
        value: 'PENDING_ACTIVATION',
      },
      {
        text: 'Paused',
        value: 'PAUSED',
      },
      {
        text: 'Active',
        value: 'ACTIVE',
      },
      {
        text: 'Ended',
        value: 'ENDED',
      },
      {
        text: 'Cancelled',
        value: 'CANCELLED',
      },
    ],
  },
  {
    label: 'Creator',
    name: 'creatorId',
    type: DrawerFilterType.SELECT,
    value: undefined,
    list: [],
  },
  {
    label: 'Start Date',
    name: 'startDate',
    type: DrawerFilterType.DATE,
    value: undefined,
  },
  {
    label: 'End Date',
    name: 'endDate',
    type: DrawerFilterType.DATE,
    value: undefined,
  },
];
